import React from 'react';
import { TbCopy, TbCopyCheck } from 'react-icons/tb';

const CopySchedulers = ({ option }) => {
  const [copied, setCopied] = React.useState(false);

  const onClick = () => {
    setCopied(true);
    navigator.clipboard.writeText(JSON.stringify(option, null, 2));
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <span style={{ cursor: 'pointer' }}>
      {copied ? (
        <TbCopyCheck size={18} />
      ) : (
        <span onClick={onClick}>
          <TbCopy size={18} />
        </span>
      )}
    </span>
  );
};

export default CopySchedulers;
